import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const PollingThresholdExceededError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Oh dear'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Something went wrong with your recording. Please try again or kindly
          contact support.
        </Text>
      }
      buttons={
        <Button onClick={() => onClose()} variant='secondary' text='Dismiss' />
      }
    />
  )
}
